var _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 320,
    height: 331,
    viewBox: "0 0 320 331",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 32,
    width: 298,
    height: 298,
    rx: 149,
    stroke: "url(#paint0_linear_16_1821)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 51,
    width: 260,
    height: 260,
    rx: 130,
    fill: "#2D8370"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16_1821)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M264.95 172.855C263.645 173.106 262.274 173.206 260.835 173.141C252.95 172.791 244.31 167.659 236.506 158.692C228.703 149.723 222.669 137.993 219.518 125.661C213.012 100.202 220.963 80.071 237.237 80.8012C253.514 81.5244 272.049 102.824 278.554 128.282C284.486 151.49 278.402 170.266 264.95 172.855ZM234.131 83.9955C221.53 86.4204 215.834 104.004 221.389 125.743C224.34 137.294 229.992 148.282 237.301 156.68C244.611 165.08 252.703 169.886 260.088 170.215C275.329 170.882 282.778 152.043 276.685 128.199C270.591 104.355 253.231 84.4044 237.987 83.7273C236.639 83.6678 235.352 83.7606 234.131 83.9955Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.901 158.212C258.999 158.386 258.054 158.453 257.07 158.409C245.987 157.916 233.367 143.412 228.937 126.078C226.791 117.681 226.864 109.88 229.144 104.11C231.421 98.3403 235.633 95.2946 241.003 95.5333C246.371 95.7714 252.255 99.2664 257.568 105.373C262.882 111.48 266.989 119.467 269.136 127.864C271.282 136.261 271.208 144.062 268.93 149.832C267.068 154.544 263.918 157.439 259.901 158.212ZM239.545 99.6063C231.521 101.151 227.894 112.347 231.432 126.19C235.311 141.372 246.365 154.075 256.073 154.507C265.775 154.936 270.521 142.938 266.64 127.753C264.76 120.399 261.162 113.403 256.508 108.054C251.854 102.706 246.701 99.6453 241.999 99.4367C241.142 99.3976 240.323 99.4565 239.545 99.6063Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.465 142.627C254.02 142.712 253.552 142.746 253.062 142.724C247.508 142.477 241.185 135.209 238.965 126.524C236.746 117.839 239.459 110.975 245.011 111.219C250.564 111.466 256.888 118.733 259.108 127.419C261.131 135.336 259.055 141.743 254.465 142.627ZM245.288 116.165C242.119 116.774 240.687 121.196 242.084 126.662C243.616 132.659 247.981 137.676 251.815 137.846C255.656 138.026 257.521 133.276 255.988 127.279C254.456 121.284 250.09 116.267 246.257 116.097C245.919 116.081 245.596 116.106 245.288 116.165Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.8656 112.406C42.542 114.934 42.542 117.795 43.8656 118.795C45.1884 119.796 47.3344 118.557 48.6579 116.029C49.9814 113.5 49.9814 110.64 48.6579 109.639C47.3344 108.638 45.1884 109.878 43.8656 112.406Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.2617 103.095C43.7555 104.542 41.399 107.204 39.6262 110.591C39.2192 111.369 39.2192 112.249 39.6262 112.557C40.0332 112.864 40.6937 112.483 41.1008 111.705C42.4793 109.071 44.3123 107.001 46.2617 105.876C48.2118 104.75 50.0441 104.704 51.4227 105.746C51.6262 105.901 51.8931 105.882 52.16 105.728C52.4268 105.574 52.6937 105.284 52.8972 104.894C53.3043 104.116 53.3043 103.237 52.8972 102.929C51.1244 101.59 48.768 101.648 46.2617 103.095Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.3987 96.2385C50.8095 92.0133 41.7151 97.2638 36.1247 107.943C35.7177 108.722 35.7177 109.601 36.1247 109.91C36.5318 110.218 37.1923 109.836 37.5993 109.058C42.3763 99.9326 50.1478 95.4456 54.9247 99.0558C55.1283 99.2094 55.3951 99.1915 55.662 99.0373C55.9289 98.883 56.1958 98.5937 56.3993 98.2046C56.8057 97.4264 56.8057 96.5464 56.3987 96.2385Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.6566 231.119L94.3891 244.821L133.158 222.438L109.313 208.641L70.6566 231.119Z",
    fill: "#585858"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.244 67.1218L153.243 67.1231C152.665 66.7455 151.894 66.7519 151.046 67.2421L39.0631 131.896C38.2055 132.391 37.4311 133.29 36.8506 134.35L46.4954 139.919V235.526L151.045 175.165C152.837 174.13 154.288 171.353 154.288 168.964V149.913L154.289 149.913V76.9695C155.238 77.0469 156.047 77.1039 156.076 77.0751C156.146 77.0047 161.515 71.8885 161.515 71.8885L153.244 67.1218Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.8188 138.093V218.312V237.362C35.8188 238.67 36.256 239.588 36.944 239.985V239.99L45.2576 244.779V236.241L46.496 235.526V139.918L36.8512 134.349C36.2188 135.503 35.8188 136.849 35.8188 138.093Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.562 154.68V74.4613C162.562 72.0728 161.11 70.9746 159.318 72.0088L47.3357 136.662C45.5443 137.696 44.0922 140.472 44.0922 142.86V223.078L162.562 154.68Z",
    fill: "#424242"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4764 216.612V141.094L159.177 76.6035V152.121L47.4764 216.612Z",
    fill: "#27DEBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4764 145.208V141.094L159.177 76.6035V80.7174L47.4764 145.208Z",
    fill: "#2D8370"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.275 221.953L93.3785 233.44V217.999L113.275 206.512V221.953Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M113.275 211.091L93.3785 222.579V217.999L113.275 206.512V211.091Z",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4764 145.208V141.094L53.6537 137.528V141.642L47.4764 145.208Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.357 162.971L81.2972 188.408V197.085L125.357 171.647V162.971Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.3718 191.476L84.151 193.913V188.285L88.3718 185.849V191.476Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.0602 188.192L89.8394 190.628V185.001L94.0602 182.564V188.192Z",
    fill: "#194E48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.7485 184.907L95.5283 187.344V181.717L99.7485 179.28V184.907Z",
    fill: "#388E3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.437 181.623L101.217 184.06V178.433L105.437 175.996V181.623Z",
    fill: "#2D8370"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.126 178.339L106.905 180.776V175.148L111.126 172.712V178.339Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.814 175.055L112.593 177.492V171.864L116.814 169.427V175.055Z",
    fill: "#388E3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.502 171.771L118.282 174.207V168.58L122.502 166.143V171.771Z",
    fill: "#2D8370"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.787 93.5896L150.923 96.3979V89.9128L155.787 87.1045V93.5896Z",
    fill: "#2D8370"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.787 104.152L150.923 106.959V100.474L155.787 97.6665V104.152Z",
    fill: "#2D8370"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.8652 163.664L57.6057 182.866V149.033L90.8652 129.832V163.664Z",
    fill: "#D5D5D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.8652 134.102L57.6057 153.304V149.033L90.8652 129.832V134.102Z",
    fill: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.8745 149.684L57.6057 153.304V149.034L63.8745 145.414V149.684Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.392 157.499L67.3306 188.135V136.427L120.392 105.792V157.499Z",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.392 110.496L67.3306 141.131V136.427L120.392 105.792V110.496Z",
    fill: "#2D8370"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.2355 137.145L67.3306 141.131V136.427L74.2355 132.441V137.145Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.0914 223.078V242.129C44.0914 244.518 45.543 245.619 47.3343 244.584L159.318 179.931C161.11 178.897 162.561 176.119 162.561 173.73V154.68L44.0914 223.078Z",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.158 198.934C106.158 201.019 104.89 203.441 103.327 204.344C101.763 205.247 100.495 204.289 100.495 202.204C100.495 200.118 101.763 197.696 103.327 196.793C104.89 195.89 106.158 196.849 106.158 198.934Z",
    fill: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.3786 233.44L85.088 228.653V222.788L93.3786 217.999V233.44Z",
    fill: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M89.4144 220.29L93.3786 222.578V217.999L89.4144 220.29Z",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.6566 233.445V231.119L94.3891 244.821V247.147L70.6566 233.445Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.158 224.764V222.438L94.389 244.821V247.147L133.158 224.764Z",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.441 253.507L165.842 237.573C164.524 236.812 162.53 236.729 161.389 237.388L141.442 248.904L138.213 247.104V251.426L138.213 251.426C138.206 251.936 138.575 252.475 139.302 252.895L191.035 282.763C191.725 283.161 192.6 283.372 193.441 283.39V253.507Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.535 266.264L193.441 253.507V283.389C194.207 283.405 194.945 283.262 195.489 282.948L217.894 270.012C218.418 269.709 218.671 269.303 218.664 268.878L218.665 268.877V264.539L215.535 266.264Z",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.574 263.123L165.842 233.255C164.524 232.495 162.53 232.412 161.389 233.071L138.983 246.007C137.841 246.666 137.985 247.817 139.302 248.578L191.035 278.445C192.353 279.206 194.347 279.289 195.488 278.63L217.894 265.695C219.035 265.035 218.893 263.884 217.574 263.123Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.586 235.637L143.428 248.43L189.087 274.791L211.245 261.998L165.586 235.637Z",
    fill: "#E0F7FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.244 261.998L189.086 274.791L153.219 254.083L143.429 248.43L165.587 235.637L174.376 240.711L211.244 261.998Z",
    fill: "#27DEBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.202 237.147L147.045 250.518L143.429 248.43L165.587 235.637L168.202 237.147Z",
    fill: "#424242"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.087 269.321C204.029 268.71 202.429 268.644 201.513 269.172C200.597 269.701 200.712 270.625 201.77 271.236C202.827 271.846 204.427 271.913 205.344 271.384C206.26 270.855 206.145 269.931 205.087 269.321Z",
    fill: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.598 238.909C155.384 238.786 155.062 238.772 154.877 238.879L149.044 242.247C148.859 242.354 148.882 242.54 149.096 242.664C149.309 242.787 149.632 242.801 149.817 242.694L155.65 239.326C155.835 239.219 155.811 239.032 155.598 238.909Z",
    fill: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.245 261.998L165.586 235.637V236.088L210.854 262.224L211.245 261.998Z",
    fill: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.428 248.43L143.837 248.666L165.586 236.109V235.637L143.428 248.43Z",
    fill: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.794 251.486C187.912 253.863 188.359 257.46 184.793 259.519C181.227 261.578 174.997 261.32 170.879 258.942C166.761 256.565 166.314 252.968 169.88 250.909C173.446 248.85 179.676 249.109 183.794 251.486Z",
    fill: "#2D8370"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.775 252.824C179.454 253.794 179.791 255.172 178.526 255.901C177.262 256.631 174.875 256.437 173.196 255.467C171.517 254.498 171.18 253.12 172.445 252.39C173.709 251.66 176.095 251.854 177.775 252.824Z",
    fill: "#424242"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.105 253.863C181.011 254.869 180.955 255.976 179.805 256.64C178.655 257.303 176.739 257.335 174.995 256.813C174.389 257.707 174.449 258.55 175.308 259.045C176.737 259.87 179.836 259.42 182.228 258.039C184.62 256.658 185.401 254.869 183.971 254.044C183.114 253.547 181.653 253.513 180.105 253.863Z",
    fill: "#424242"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.317 236.121C198.599 237.421 198.599 241.135 200.317 244.418C202.036 247.7 204.821 249.309 206.539 248.01C208.258 246.711 208.258 242.997 206.539 239.714C204.822 236.43 202.036 234.822 200.317 236.121Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.428 227.625C200.174 225.746 197.114 225.67 194.813 227.41C194.284 227.81 194.284 228.953 194.813 229.962C195.342 230.973 196.2 231.467 196.728 231.067C198.518 229.714 200.897 229.774 203.428 231.235C205.96 232.697 208.34 235.385 210.13 238.805C210.394 239.31 210.74 239.686 211.087 239.887C211.434 240.087 211.78 240.111 212.045 239.91C212.573 239.51 212.573 238.369 212.045 237.358C209.743 232.961 206.684 229.505 203.428 227.625Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.591 233.92C209.334 220.055 197.525 213.236 190.267 218.722C189.738 219.122 189.738 220.264 190.267 221.274C190.795 222.284 191.653 222.779 192.181 222.379C198.384 217.693 208.474 223.518 214.676 235.367C214.941 235.872 215.287 236.248 215.634 236.448C215.98 236.648 216.327 236.672 216.591 236.471C217.119 236.073 217.119 234.93 216.591 233.92Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.082 225.533V235.578L184.134 192.884V182.839L258.082 225.533Z",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.895 226.217L223.283 206.811V214.117L256.895 233.523V226.217Z",
    fill: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.082 225.533L284.181 210.464V220.51L258.082 235.578V225.533Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.181 210.464L210.233 167.77L184.134 182.839L258.082 225.533L284.181 210.464Z",
    fill: "#B8B8B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.316 214.571C282.545 214.438 282.732 214.58 282.732 214.886V218.74C282.732 219.046 282.545 219.403 282.316 219.536C282.086 219.669 281.899 219.527 281.899 219.221V215.367C281.9 215.061 282.086 214.704 282.316 214.571Z",
    fill: "#757575"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.41 215.672C280.639 215.539 280.826 215.68 280.826 215.987V219.84C280.826 220.147 280.64 220.504 280.41 220.637C280.18 220.77 279.993 220.628 279.993 220.322V216.468C279.993 216.161 280.179 215.805 280.41 215.672Z",
    fill: "#757575"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.503 216.773C278.733 216.64 278.92 216.781 278.92 217.088V220.941C278.92 221.248 278.733 221.604 278.503 221.737C278.273 221.871 278.086 221.729 278.086 221.423V217.569C278.086 217.262 278.273 216.905 278.503 216.773Z",
    fill: "#757575"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.597 217.873C276.827 217.74 277.014 217.881 277.014 218.188V222.041C277.014 222.348 276.828 222.704 276.597 222.838C276.367 222.97 276.181 222.829 276.181 222.523V218.669C276.181 218.363 276.367 218.006 276.597 217.873Z",
    fill: "#757575"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.691 218.974C274.92 218.841 275.107 218.982 275.107 219.289V223.142C275.107 223.449 274.921 223.805 274.691 223.938C274.461 224.071 274.274 223.93 274.274 223.624V219.77C274.274 219.463 274.461 219.107 274.691 218.974Z",
    fill: "#757575"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.784 220.075C273.014 219.942 273.201 220.083 273.201 220.39V224.243C273.201 224.55 273.014 224.906 272.784 225.039C272.554 225.172 272.367 225.031 272.367 224.724V220.871C272.367 220.564 272.554 220.207 272.784 220.075Z",
    fill: "#757575"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.144 203.022C212.144 203.92 212.69 204.963 213.363 205.352C214.037 205.741 214.582 205.328 214.582 204.43C214.582 203.532 214.037 202.489 213.363 202.1C212.69 201.711 212.144 202.124 212.144 203.022Z",
    fill: "#C7AA2A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.795 200.501C207.795 201.399 208.34 202.442 209.014 202.831C209.687 203.22 210.233 202.807 210.233 201.909C210.233 201.011 209.687 199.968 209.014 199.579C208.34 199.19 207.795 199.603 207.795 200.501Z",
    fill: "#C7AA2A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.444 197.98C203.444 198.878 203.99 199.921 204.664 200.31C205.337 200.698 205.883 200.286 205.883 199.388C205.883 198.49 205.337 197.447 204.664 197.058C203.99 196.669 203.444 197.082 203.444 197.98Z",
    fill: "#C7AA2A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.094 195.459C199.094 196.357 199.64 197.4 200.314 197.789C200.987 198.178 201.533 197.765 201.533 196.867C201.533 195.969 200.987 194.926 200.314 194.537C199.64 194.149 199.094 194.562 199.094 195.459Z",
    fill: "#C7AA2A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.745 192.939C194.745 193.837 195.291 194.88 195.964 195.268C196.637 195.657 197.183 195.245 197.183 194.347C197.183 193.449 196.637 192.406 195.964 192.017C195.29 191.628 194.745 192.041 194.745 192.939Z",
    fill: "#C7AA2A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.045 187.897C186.045 188.795 186.591 189.838 187.264 190.226C187.937 190.615 188.483 190.203 188.483 189.305C188.483 188.407 187.937 187.364 187.264 186.975C186.591 186.586 186.045 186.999 186.045 187.897Z",
    fill: "#66BB6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.74 200.411L268.936 138.87L264.627 136.334L262.431 197.878L266.74 200.411Z",
    fill: "#616161"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.936 138.87L271.131 137.602V202.932L266.74 200.411L268.936 138.87Z",
    fill: "#4F4F4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.131 137.602L266.74 135.067L264.627 136.334L268.936 138.87L271.131 137.602Z",
    fill: "#4F4F4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.591 177.801L229.787 116.26L225.478 113.725L223.283 175.268L227.591 177.801Z",
    fill: "#616161"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.787 116.26L231.982 114.992V180.322L227.591 177.801L229.787 116.26Z",
    fill: "#4F4F4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.982 114.992L227.591 112.457L225.478 113.725L229.787 116.26L231.982 114.992Z",
    fill: "#4F4F4F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_16_1821",
    x1: 150,
    y1: 31,
    x2: 150,
    y2: 331,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.510001,
    stopColor: "#57E3AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16_1821"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 320,
    height: 320,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdge);
export default __webpack_public_path__ + "static/media/Edge.1293758a5f542ff3e5eba23c07cb169b.svg";
export { ForwardRef as ReactComponent };